module.exports = __webpack_public_path__ + "img/coin.e6a5805c.png";